<script setup >
import { onMounted, onUnmounted, provide } from 'vue'
import stripslashes, { replaceS3path } from '@/Shared/helper.js'
import { brandHasCarousel } from '@/Shared/helper-contents.js'
import V2visual from '@/Pages/Brand/V2Components/DetailV2Visual'
import V2intro from '@/Pages/Brand/V2Components/DetailV2Intro'
import V2carousel from '@/Pages/Brand/V2Components/DetailV2Carousel'
import V2halfbox from '@/Pages/Brand/V2Components/DetailV2Halfbox'
import V2video from '@/Pages/Brand/V2Components/DetailV2Video'
import V2freeHtml from '@/Pages/Brand/V2Components/DetailV2FreeHtml'
import V2product from '@/Pages/Brand/V2Components/DetailV2Product'
import V2news from '@/Pages/Brand/V2Components/DetailV2News'

const props = defineProps({
  brandInfo: Array,
  myCategories: Array,
  myProducts: Array,
  myNews: Array,
  pref: Object,
})

provide('data', props.brandInfo[0])

const css = (props.brandInfo[0].extra !== null && typeof props.brandInfo[0].extra.brandDetailCSS !== 'undefined') ? `<style>${replaceS3path(stripslashes(props.brandInfo[0].extra.brandDetailCSS))}</style>` : ''
let precss = '<style>'
let postcss = '</style>'

precss += '.brandcolor { color: ' + props.brandInfo[0].brandPMSbrandColor + ' !important; } '
precss += '.brandcolorBtn { background-color: ' + props.brandInfo[0].brandPMSbrandColor + ' !important; } '
precss += '.new-box{ background-color: ' + props.brandInfo[0].brandPMSbrandColor + ' !important; } '
precss += 'a.btn-shop{ background-color: ' + props.brandInfo[0].brandPMSbrandColor + ' !important; color:#FFF; } '
precss += 'a.btn-shop.dark{ color: ' + props.brandInfo[0].brandPMSbrandColor + ' !important; } '
precss += '.brand-half-box .title{ color: ' + props.brandInfo[0].brandPMSbrandColor + ' !important; } '
precss += '.brand-products .product-header .product-category .category-list .dropdown li.active a .category-name{ color: ' + props.brandInfo[0].brandPMSbrandColor + ' !important; } '
const customcss = ( props.brandInfo[0].brandPMSbrandColor ) ? precss + postcss : ''

onMounted(() => {})
onUnmounted(() => { })
</script>
<template>
  <div id="brandDetail_v2">
    <V2visual />
    <V2intro />

    <template v-if="brandHasCarousel(brandInfo[0])">
      <V2carousel :carousel="brandInfo[0].carousel" /> 
    </template>

    <template v-if="brandInfo[0].extra">
      <V2halfbox :extra="brandInfo[0].extra" :brand-info="brandInfo[0]" />
    </template>

    <template v-if="brandInfo[0].extra.brandDetailHTML2">
      <V2video />
    </template>

    <template v-if="brandInfo[0].extra.brandDetailHTML">
      <V2freeHtml />
    </template>
      
    <div id="brand-products" class="my-12 sm:my-28 md:my-32 scroll-mt-[55px] md:scroll-mt-[75px] xl:scroll-mt-0">
      <div class="contentsContainer 3xl:!max-w-[1200px] 4xl:!max-w-[1400px]">
        <V2product :brand-info="brandInfo" :my-categories="myCategories" :my-products="myProducts" />
      </div>
    </div>
            
    <V2news :brand-info="brandInfo" :news="myNews" />
  </div>
  
  <div v-html="customcss" />
  <div v-html="css" />
</template>
